import { render, staticRenderFns } from "./ExplorePress.vue?vue&type=template&id=5489cf36&scoped=true"
import script from "./ExplorePress.vue?vue&type=script&lang=js"
export * from "./ExplorePress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489cf36",
  null
  
)

export default component.exports